import moment from 'moment';
import 'moment-timezone';

import { differenceInDays, differenceInHours, format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { IAuditionScheduleAttributes, IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';

export const selftapesDueComputer = (dueDate: string, timezone: string, whole?: boolean) => {
  if (!dueDate || !timezone) return 'N/A';

  const endDateString = dueDate;

  // Parse the ISO strings into Date objects
  const startDate = new Date();
  const endDate = parseISO(endDateString);

  // Convert the dates to the desired timezone
  const startDateInTimezone = utcToZonedTime(startDate, moment.tz.guess());
  const endDateInTimezone = utcToZonedTime(endDate, timezone);

  console.log('my timezone', moment.tz.guess());

  // Calculate the difference in days
  const daysDifference = differenceInDays(endDateInTimezone, startDateInTimezone);

  // Calculate the difference in hours
  const hoursDifference = differenceInHours(endDateInTimezone, startDateInTimezone);
  const remainingHours = hoursDifference % 24;

  return `${daysDifference}D ${remainingHours}H`;
};

export const audDateTime = (sched: IAuditionSchedulesAttributes | IAuditionScheduleAttributes) => {
  const dte = sched.schedule?.time_in ? sched.schedule?.time_in : sched.checked_in_at;
  if (!sched.checked_in_at && !sched.schedule?.time_in) {
    return '--';
  }

  return new Date(dte || '');
};

export const stDateTime = (data: IAuditionSchedulesAttributes | IAuditionScheduleAttributes) => {
  const date = data.audition.casting_role.self_tapes_requirements?.date || '';
  const time = data.audition.casting_role.self_tapes_requirements?.time || '';
  const timezone = data.audition.casting_role.self_tapes_requirements?.timezone || '';

  const dueDate = date.split('T')[0];

  const timeIn24HourFormat = moment(time, 'h:mm A').format('HH:mm');

  return new Date(dueDate + 'T' + timeIn24HourFormat);
};

export const STTimeDateParser = (date: string, time: string, timeZone: string) => {
  if (!date || !time) return 'N/A';

  const dueDate = date.split('T')[0];

  const timeIn24HourFormat = moment(time, 'h:mm A').format('HH:mm');
  //   // Combine the time and date strings
  const dateTimeString = `${dueDate}T${timeIn24HourFormat}`;

  return moment.tz(dateTimeString, timeZone).format('Do MMM YYYY (hh:mmA z)');
};

export const timeConvert = (sched: IAuditionSchedulesAttributes | IAuditionScheduleAttributes) => {
  const dte = sched.schedule?.time_in ? sched.schedule?.time_in : sched.checked_in_at;
  if (!sched.checked_in_at && !sched.schedule?.time_in) {
    return '--';
  }
  const checkinDate = dte ? new Date(dte.toString().slice(0, 19)) : new Date();
  const timeZone = sched.schedule?.casting_session?.casting_location.address?.timezone;
  const Z = moment.tz(checkinDate, timeZone).format('z');
  return `${format(checkinDate, 'do MMM yyyy (hh:mmb')} ${Z})`;
};

const timeRemain = (dateTime: Date, timezone: string, whole?: boolean) => {
  if (isNaN(dateTime.getTime())) return 'N/A';

  const iso8601Date = dateTime.toISOString();

  if (!dateTime || !timezone) return 'N/A';

  const userTimezone = moment.tz.guess();
  //date today in user timezone
  const startDateInTimezone = utcToZonedTime(new Date(), userTimezone);
  // const endDateInTimezone = utcToZonedTime(iso8601Date, timezone);
  const endDateInTimezone = moment(iso8601Date).tz(timezone, true)?.toDate();

  if (!startDateInTimezone || !endDateInTimezone) return 'N/A';

  // Calculate the difference in days
  const daysDifference = differenceInDays(endDateInTimezone, startDateInTimezone);

  // Calculate the difference in hours
  const hoursDifference = differenceInHours(endDateInTimezone, startDateInTimezone);
  const remainingHours = hoursDifference % 24;

  const isNegative = (num: number) => {
    if (Math.sign(num) === -1) {
      return true;
    }

    return false;
  };

  if (isNegative(hoursDifference) || isNegative(daysDifference)) return 'Late';

  return whole
    ? `${daysDifference > 0 ? daysDifference + `${daysDifference > 1 ? ' days' : ' day'}` : ''} ${
        remainingHours > 1 ? remainingHours + ' hours' : remainingHours + ' hour'
      } left`
    : `${daysDifference > 0 ? daysDifference + 'D' : ''} ${remainingHours}H`;
};

export const timeParser = (date: string, time: string, timezone: string, whole?: boolean) => {
  if (!date || !timezone) return 'N/A';

  const dueDate = date.split('T')[0];

  const timeIn24HourFormat = moment(time, 'h:mm A').format('HH:mm');
  //   // Combine the time and date strings
  const dateTimeString = `${dueDate}T${timeIn24HourFormat}`;
  //   // Create a new Date object from the combined date and time
  const dateObject = new Date(dateTimeString);
  //   // Use the toISOString() method to get the ISO-8601 formatted date

  return timeRemain(dateObject, timezone, whole);
};

export const auditionTimeParse = (sched: IAuditionSchedulesAttributes | IAuditionScheduleAttributes) => {
  if (!sched) return 'N/A';
  const dte = sched.schedule?.time_in ? sched.schedule?.time_in : sched.checked_in_at;
  if (!sched.checked_in_at && !sched.schedule?.time_in) {
    return 'N/A';
  }
  const checkinDate = dte ? new Date(dte.toString().slice(0, 19)) : new Date();
  const timeZone = sched.schedule?.casting_session?.casting_location.address?.timezone;
  return timeRemain(checkinDate, timeZone);
};
